import { render, staticRenderFns } from "./managedInstructionAssignmentAssignedDialogDueDate.vue?vue&type=template&id=2b469673"
import script from "./managedInstructionAssignmentAssignedDialogDueDate.vue?vue&type=script&lang=js"
export * from "./managedInstructionAssignmentAssignedDialogDueDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports